import { REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT } from '../../constants/key'
import {
  getDayDateStrDateUtil,
  getMonthStrDateUtil,
  getWeekStrDateUtil,
  getYearStrDateUtil,
  logUtil
} from 'packages/src'

const DATE_PERIOD_UNIT_TO_FN_MAP = {
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.YEAR]: getYearStrDateUtil,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.MONTH]: getMonthStrDateUtil,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.WEEK]: getWeekStrDateUtil,
  [REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.DAY]: getDayDateStrDateUtil
}

function getDatePeriodStrReduxUtil (value, datePeriodUnit) {
  const func = DATE_PERIOD_UNIT_TO_FN_MAP[datePeriodUnit]
  logUtil('getDatePeriodStrReduxUtil').debug(`[start] value=${value} datePeriodUnit=${datePeriodUnit}`)
  if (!func) {
    logUtil('getDatePeriodStrReduxUtil').warn('[notFound]')
    return
  }
  return func(value)
}

export { getDatePeriodStrReduxUtil }
